import ReviewsLanding from './ReviewsLanding/ReviewsLanding.js';
import ZillowReviews from './ZillowReviews/ZillowReviews.js';
import ReviewGrid from './ReviewGrid/ReviewGrid.js';

function Reviews() {
    return (
        <>
            <ReviewsLanding/>
            <ZillowReviews/>
            <ReviewGrid/>
        </>
    );
}

export default Reviews;
